import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import "@/shared/ui/media/logos/styles/logo-base.scss";

type LogoBaseProps = {
    imageLink: string;
    logoLink: string;
    alt?: string;
    width?: number;
    height?: number;
};

export function LogoBase(props: LogoBaseProps): JSX.Element {
    const {imageLink, logoLink, alt = "Logo", width = 222, height = 72} = props;
    return (
        <Link href={logoLink} className="logo-base">
            <SmartImage src={imageLink} alt={alt} width={width} height={height} priority={true} />
        </Link>
    );
}
